"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.Flyout = void 0;
require("./Flyout.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _OverlayDefaultContent = _interopRequireDefault(require("../OverlayDefaultContent/OverlayDefaultContent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Flyout component
 *
 * @method
 * @param { FlyoutProps } props
 * @returns Flyout
 */

const Flyout = props => {
  const {
    ariaLabel,
    ariaLabelledby,
    title,
    titleTag,
    description,
    children,
    className,
    alignment = defaultProps.alignment,
    externalBackActionElement,
    externalCloseActionElement,
    externalFooterChildrenElements,
    isOpen = defaultProps.isOpen,
    panelRef,
    variant = defaultProps.variant,
    showBackButton,
    supportText
  } = props;
  const componentClassName = (0, _classnames.default)('pal-c-Flyout', {
    [`pal-c-Flyout__align--${alignment}`]: alignment,
    'pal-c-Flyout__open': isOpen
  }, className);
  const defaultContent = /*#__PURE__*/_react.default.createElement(_OverlayDefaultContent.default, {
    title: title,
    titleTag: titleTag,
    description: description,
    showBackButton: showBackButton,
    showCloseButton: true,
    showHeaderDivider: true,
    showFooterDivider: true,
    externalBackActionElement: externalBackActionElement,
    externalCloseActionElement: externalCloseActionElement,
    externalFooterChildrenElements: externalFooterChildrenElements,
    supportText: supportText
  }, children);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName,
    ref: panelRef,
    role: "dialog",
    "aria-modal": "true",
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabel ? undefined : ariaLabelledby
  }, variant === 'default' && defaultContent, variant === 'custom' && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-Flyout__customContent"
  }, children));
};

/**
 * Property type definitions
 * @typedef FlyoutProps
 * @type {object}
 * @property {string} ariaLabel - value for aria label
 * @property {string} ariaLabelledby -  HTML id for aria-labelledby
 * @property {string} title - Title for the Flyout header.
 * @property {string} description - Description for the Flyout header.
 * @property {object} children - Scrollable content for the Flyout body.
 * @property {string} className - Sets the additional className to the Flyout container div.
 * @property {object} externalFooterChildrenElements - Footer content for the Flyout.
 * @property {object} externalBackActionElement - Back action element with business and DC logic from web-site.
 * @property {object} externalCloseActionElement - Close action element with business and DC logic from web-site.
 * @property {string} alignment - Sets the direction from where the flyout will appear (left, right)
 * @property {boolean} isOpen - Controls the open/closed state of the flyout for animation.
 * @property {any} panelRef - Sets the ref of the Flyout container.
 * @property {string} variant - Sets the variant of the Flyout content (default, custom)
 * @property {string} supportText - Displays support text below the footer actions for default variant.
 * @property {string} titleTag - HTML tag of the title - default set in TitlesDefault
 * @property {boolean} showBackButton - show/hide the back button in the flyout header
 */
exports.Flyout = Flyout;
const propTypes = exports.propTypes = {
  /**
   * value for aria label
   */
  ariaLabel: _propTypes.default.string,
  /**
   * HTML id for aria-labelledby
   */
  ariaLabelledby: _propTypes.default.string,
  /**
   * Title for the Flyout header.
   */
  title: _propTypes.default.string,
  /**
   * Description for the Flyout header.
   */
  description: _propTypes.default.string,
  /**
   * Scrollable content for the Flyout body.
   */
  children: _propTypes.default.object,
  /**
   * Sets the additional className to the Flyout container div.
   */
  className: _propTypes.default.string,
  /**
   * Sets the ref of the Flyout container.
   */
  /**
   * Footer content for the Flyout.
   */
  externalFooterChildrenElements: _propTypes.default.object,
  /**
   * Back action element with business and DC logic from web-site.
   */
  externalBackActionElement: _propTypes.default.object,
  /**
   * Close action element with business and DC logic from web-site.
   */
  externalCloseActionElement: _propTypes.default.object,
  /**
   * Sets the direction from where the flyout will appear (left, right)
   */
  alignment: _propTypes.default.oneOf(['left', 'right']),
  /**
   * Controls the open/closed state of the flyout for animation.
   */
  isOpen: _propTypes.default.bool,
  /**
   * Sets the ref of the Flyout container.
   */
  panelRef: _propTypes.default.any,
  /**
   * Sets the variant of content rendered for the Flyout (default, custom)
   * - default:  uses OverlayDefaultContent component to render default Overlay with sticky header and footer
   * - custom: can be used to configured the Flyout with custom content for header, body and footer
   */
  variant: _propTypes.default.oneOf(['default', 'custom']),
  /**
   * Displays support text below the footer actions for default variant.
   */
  supportText: _propTypes.default.string,
  /**
     * HTML tag of the title - default set in TitlesDefault
     */
  titleTag: _propTypes.default.string,
  /**
     * show/hide the back button in the flyout header
     */
  showBackButton: _propTypes.default.bool
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} alignment - alignment: 'right' - sets the Flyout to open from right.
 * @property {boolean} isOpen - isOpen: false - sets the default open state of the Flyout to be false
 * @property {string} variant - variant: 'default' - sets the default variant to render OverlayDefaultContent component.
 */
const defaultProps = exports.defaultProps = {
  alignment: 'right',
  isOpen: false,
  variant: 'default'
};
Flyout.propTypes = propTypes;
Flyout.defaultProps = defaultProps;
var _default = exports.default = Flyout;